import 'css-chunksrc/client/common/resourcesPicker/styles.scss';export default {
  "resourcesPicker": "_resourcesPicker_go6ar_1",
  "title": "_title_go6ar_8",
  "addIcon": "_addIcon_go6ar_15",
  "list": "_list_go6ar_21",
  "resources": "_resources_go6ar_1",
  "resource": "_resource_go6ar_1"
};